// appends values in formData to form to be ready to be posted
export const appendFormData = (formData) => {
  const fd = new FormData();
  Object.entries(formData)
    .forEach(([key, value]) => {
      fd.append(key, value);
    });
  // console.log(...fd)
  return fd;
}